module.exports = __webpack_public_path__ + "img/pic03.b99f1f6f.png";